import { mergeCandy } from "./index";
import { mergeCandyBootDefaults } from "./boot/bootDefaults";
import { launchGame } from "@slot/game-shell";

void launchGame(mergeCandy, import.meta.env, mergeCandyBootDefaults);
